import $ from "jquery";
import { component } from "picoapp";
import {
  handleize,
  setQueryStringParameter,
  getSelectedVariant,
  getQueryStringParameter,
} from "../lib/utils";
import getProductJson from "../lib/getProductJson";
import { isKlarnaEnabled } from "../lib/themeSettings";
import { store } from "@/vue/config/store";
import { formatMoney } from "../lib/currency";

const variantId = (variant) => {
  return `#${handleize(variant.title)}`;
};

const handleATCState = (variant, dataEventFor) => {
  const selectInput = document.getElementById(dataEventFor);
  const $variantOption = $(selectInput).find(variantId(variant));
  const preOrder = $variantOption.data("preorder");
  const hideWaitList = $variantOption.data("hidewaitlistbutton");
  const buttonText = preOrder
    ? "Pre-Order Now"
    : window.theme.strings.addToCart;
  let variantAvailable = variant.available;
  if ($variantOption.data("bundleVariant")) {
    variantAvailable = !$variantOption.data("oos");
  }

  if (variantAvailable) {
    const $button = $(".js-add-to-cart");
    $button.show();
    $button.attr("disabled", false);
    $button.toggleClass(["hide"], false);
    $button.toggleClass(["disabled"], false);
    $button
      .find(".js-default-cta-text")
      .each((_index, el) => $(el).text(buttonText));
    $(".oos-text").html("");
  } else if (!hideWaitList && !variant.available) {
    const $button = $(".js-add-to-cart");
    $button.toggleClass(["hide"], true);
  } else {
    const $button = $(".js-add-to-cart");
    $button.show();
    $button.attr("disabled", true);
    $button.toggleClass(["hide"], false);
    $button.toggleClass(["disabled"], true);
    $button
      .find(".js-default-cta-text")
      .each((_index, el) => $(el).text("Sold Out"));
    const oosText = $(variantId(variant)).data("outOfStockText");
    if (oosText) {
      $(".oos-text").html(oosText);
    } else {
      $(".oos-text").html(
        `<p><span>${variant.title} is completely sold out</span><br> Grab another color before it disappears too!</p>`
      );
    }
  }

  if (hideWaitList) {
    $(".waitlist-button-container").hide();
  } else {
    $(".waitlist-button-container").show();
  }
};

const handleShippingNotes = (currentVariant, selectId) => {
  const selectInput = document.querySelector(`select#${selectId}`);
  const optionElement = document.getElementById(
    `${selectId}-${handleize(currentVariant.option1)}`
  );
  if (!optionElement) return;
  const optionPosition = optionElement.dataset.position;
  const shippingNoteText = selectInput.querySelector(
    `option[value="${currentVariant.id}"]`
  ).dataset.shippingnote;
  const shippingNoteElements = document.querySelectorAll(".js-shippingnote");
  shippingNoteElements.forEach((element) => {
    const position = element.dataset.position;
    if (position === optionPosition) {
      element.innerHTML = shippingNoteText;
    } else {
      element.innerHTML = "";
    }
  });
};

export const handleOptionsState = (currentVariant, variants, dataEventFor) => {
  if (currentVariant.options.length < 2) {
    return;
  }

  const oosClass = "oos-true";
  const hiddenClass = "hidden-option";
  const optionsWrapper = document.querySelector(
    `[data-event-for="${dataEventFor}"]`
  );
  const optionsInputs = optionsWrapper.querySelectorAll(
    '.radio-group input[type="radio"]'
  );
  const optionSwatches = optionsWrapper.querySelectorAll("label.radio");
  const matchingPrimaryOptionVariants = variants.filter(
    (v) => v.option1 === currentVariant.option1
  );
  let nonPrimaryOptionValues = [];

  const nonPrimaryOptionInputs = [...optionsInputs].filter(
    (optionInput) => optionInput.dataset.position > 1
  );
  if (nonPrimaryOptionInputs.length) {
    nonPrimaryOptionValues = [...nonPrimaryOptionInputs].map((_o) => _o.value);
  }

  // Clean swatch ui states
  [...optionSwatches].forEach((swatchEl) => {
    swatchEl.classList.remove(oosClass, hiddenClass);
  });

  const addOutOfStockStates = (optionValue) => {
    const input = optionsWrapper.querySelector(`input[value="${optionValue}"]`);
    const swatch = optionsWrapper.querySelector(`label[for="${input.id}"]`);
    swatch.classList.add(oosClass);
  };

  const addHiddenVariantStates = (optionValue) => {
    const input = optionsWrapper.querySelector(`input[value="${optionValue}"]`);
    const swatch = optionsWrapper.querySelector(`label[for="${input.id}"]`);
    swatch.classList.add(hiddenClass);
  };

  // Add swatch ui states
  if (!currentVariant.available) {
    currentVariant.options.forEach((option, index) => {
      if (index < 1) return;
      addOutOfStockStates(option);
    });
  }

  // Handle out of stock options
  variants.forEach((variant) => {
    // Check if variant is available
    if (!variant.available) {
      // Check if unavailable variant has any options within the current variant options
      if (
        currentVariant.options.some((_option) =>
          variant.options.includes(_option)
        )
      ) {
        variant.options.forEach((option, index) => {
          if (index < 1) return;
          if (!currentVariant.options.includes(option)) {
            addOutOfStockStates(option);
          }
        });
      }
    }
  });

  // Handle hidden/non-existent variant options
  const nonHiddenVariants = matchingPrimaryOptionVariants.filter((v) =>
    document.querySelector(variantId(v))
  );
  const hiddenOptions = nonPrimaryOptionValues.filter((optionValue) => {
    return !nonHiddenVariants.find(
      (v) => v.option2 === optionValue || v.option3 === optionValue
    );
  });

  hiddenOptions.forEach((hiddenOption) => addHiddenVariantStates(hiddenOption));
};

const handlePrice = (_node, selectId, variant, product) => {
  const pdpUpsell = document.querySelector('input[name="pdp-upsell-active"]');
  const setsEnabled =
    parseInt(_node.querySelector('input[name="quantity"]').value) > 1;
  const mainVariantSelect = document.getElementById(selectId);
  const mainVariantOption =
    mainVariantSelect.options[mainVariantSelect.selectedIndex];
  const mainVariantPrice = mainVariantOption.dataset.price;
  const mainVariantComparePrice = mainVariantOption.dataset.compareAtPrice;

  if (pdpUpsell && pdpUpsell.checked) {
    let newPrice = pdpUpsell.dataset.price;
    const newComparePrice = pdpUpsell.dataset.comparePrice;
    if (!newPrice) {
      const upsellVariantSelect = document.getElementById(selectId);
      const upsellVariantOption =
        upsellVariantSelect.options[upsellVariantSelect.selectedIndex];
      const upsellVariantPrice = upsellVariantOption.dataset.price;
      newPrice = parseInt(mainVariantPrice) + parseInt(upsellVariantPrice);
    }

    const priceEvent = new CustomEvent("price:update", {
      detail: {
        price: newPrice,
        comparePrice: newComparePrice,
      },
    });
    window.dispatchEvent(priceEvent);
  } else if (setsEnabled) {
    const variantSetPrice = store.getters["metafields/getVariantSetPrice"](
      variant.id
    );
    const variantSetComparePrice = store.getters[
      "metafields/getVariantSetCompareAtPrice"
    ](variant.id);
    const productSetPrice = store.getters["metafields/getProductSetPrice"](
      parseInt(product.id)
    );
    const productSetComparePrice = store.getters[
      "metafields/getProductSetCompareAtPrice"
    ](parseInt(product.id));

    window.dispatchEvent(
      new CustomEvent("price:update", {
        detail: {
          price: variantSetPrice || productSetPrice,
          comparePrice: variantSetComparePrice || productSetComparePrice,
        },
      })
    );
  } else {
    const priceEvent = new CustomEvent("price:update", {
      detail: {
        price: mainVariantPrice,
        comparePrice: mainVariantComparePrice,
      },
    });
    window.dispatchEvent(priceEvent);
  }
};

const handleSetSavings = (node, variant, product) => {
  const savings = node.querySelector("[data-set-savings]");
  if (!savings) return;
  const variantSetPrice = store.getters["metafields/getVariantSetPrice"](
    variant.id
  );
  const variantSetComparePrice = store.getters[
    "metafields/getVariantSetCompareAtPrice"
  ](variant.id);
  const productSetPrice = store.getters["metafields/getProductSetPrice"](
    parseInt(product.id)
  );
  const productSetComparePrice = store.getters[
    "metafields/getProductSetCompareAtPrice"
  ](parseInt(product.id));

  if (variantSetPrice) {
    savings.innerHTML = formatMoney(
      variantSetComparePrice - variantSetPrice,
      // eslint-disable-next-line no-template-curly-in-string
      "${{ amount_no_trailing_zeroes }}",
      false
    );
  } else if (productSetPrice) {
    savings.innerHTML = formatMoney(
      productSetComparePrice - productSetPrice,
      // eslint-disable-next-line no-template-curly-in-string
      "${{ amount_no_trailing_zeroes }}",
      false
    );
  }
};

export const handleOptionTitle = (variant, dataEventFor) => {
  const optionsWrapper = document.querySelector(
    `[data-event-for="${dataEventFor}"]`
  );

  const optionTitleElements = optionsWrapper.querySelectorAll(`.js-option`);
  const optionDescriptionElements = optionsWrapper.querySelectorAll(
    ".option-description"
  );
  const selectedOptions = variant.options;
  const optionsMap = {};
  const optionsDescriptionMap = {};
  selectedOptions.forEach((option) => {
    const optionHandle = handleize(option);
    const inputEl = document.getElementById(`${dataEventFor}-${optionHandle}`);
    if (inputEl) {
      const inputOptionPosition = inputEl.dataset.position;
      const optionDescription = inputEl.dataset.description;
      optionsMap[inputOptionPosition] = option;
      optionsDescriptionMap[inputOptionPosition] = optionDescription;
    }
  });

  optionTitleElements.forEach((optionTitleEl) => {
    const position = optionTitleEl.dataset.position;
    optionTitleEl.innerHTML = optionsMap[position] || null;
  });

  optionDescriptionElements.forEach((optionDescriptionEl) => {
    const position = optionDescriptionEl.dataset.position;
    optionDescriptionEl.innerHTML = optionsDescriptionMap[position] || "";
  });
};

async function handleKlarna(variant) {
  const isEnabled = await isKlarnaEnabled();
  if (isEnabled !== "false") {
    document
      .getElementsByTagName("klarna-placement")[0]
      .setAttribute("data-purchase-amount", variant.price);
    window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
    window.KlarnaOnsiteService.push({ eventName: "refresh-placements" });
  }
}

export const handleVariantNotes = (variant) => {
  const variantNotes = $(variantId(variant)).data("variantnotes");
  if (variantNotes !== "") {
    $(".js-variantnotes").html(variantNotes);
    $(".js-variantnotes").show();
  } else {
    $(".js-variantnotes").html("");
    $(".js-variantnotes").hide();
  }
};

export const reselectVariant = (lastClickedOption, variants, selectId) => {
  const variantToSelect = variants.find((v) => {
    const variantOptionElement = document.getElementById(handleize(v.title));
    if (!variantOptionElement) return false;
    if (v.options.includes(lastClickedOption)) {
      return true;
    }

    return false;
  });

  if (variantToSelect) {
    const reselectOption = variantToSelect.options.filter(
      (option) => option !== lastClickedOption
    );
    const optionInputId = handleize(`${selectId}-${reselectOption[0]}`);
    const newOption = document.getElementById(optionInputId);
    newOption.click();
    return newOption;
  }

  return false;
};

export default component((node, context) => {
  const initialVariantId = node.dataset.initialVariantId;
  const redirectVariant = node.dataset.redirectVariant;

  if (redirectVariant === "true") {
    window.location.search = `?variant=${initialVariantId}`;
  }

  // deep link variant on inital load of PDP if variant param not included
  // in link (specifically used for products linked in navigation menu)

  if (getQueryStringParameter("variant")) {
    setQueryStringParameter("variant", initialVariantId);
  }

  window.addEventListener("variant-selected:id", async (event) => {
    const product = await getProductJson();
    const { variant: variantId, lastClickedOption } = event.detail;
    const variant = product.variants.find(
      (v) => parseInt(v.id) === parseInt(variantId)
    );
    const selectId = "id";

    if (!variant) {
      // Triggers when selecting a variant that is hidden on multioption products
      // Find closest available varaint
      reselectVariant(lastClickedOption, product.variants, selectId);
    }

    const { currentVariant } = context.getState();
    if (currentVariant.id === parseInt(variant)) {
      return false;
    }

    getSelectedVariant(product.handle, variantId);
    context.hydrate({ currentVariant: variant });
    // deep link variant
    setQueryStringParameter("variant", variant.id);
    handleATCState(variant, selectId);
    handleOptionsState(variant, product.variants, selectId);
    handleVariantNotes(variant);
    handleOptionTitle(variant, selectId);
    handleShippingNotes(variant, selectId);
    handlePrice(node, selectId, variant, product);
    handleSetSavings(node, variant, product);
    handleKlarna(variant);
  });

  getProductJson().then((product) => {
    const variantId = parseInt(initialVariantId);
    const initialVariantEvent = new CustomEvent("variant-selected:id", {
      detail: {
        product: product.handle,
        variant: variantId,
        options: product.options,
        lastClickedOption: null,
      },
    });

    window.dispatchEvent(initialVariantEvent);
  });
});
